import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

import { VAR_AREA_BOT } from '@mopla/constants';

export const Root = styled('div')(({ theme }) => ({
	height: '100%',
	width: '100%',
	padding: '24px',
	paddingBottom: `calc(24px + ${VAR_AREA_BOT})`,
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	background: theme.palette.neutral[20],
	boxSizing: 'border-box',
}));

export const HeaderBlock = styled('header')(() => ({
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
}));

export const Content = styled('main')(() => ({
	alignItems: 'center',
	width: '100%',
	overflow: 'auto',
}));

export const GreenDivider = styled(Divider)(({ theme }) => ({
	...theme.typography.body2,
	textTransform: 'uppercase',
	width: '100%',
	color: theme.palette.neutral[80],
}));

export const SocialWrapper = styled('div')(() => ({
	margin: '16px 0',
	display: 'flex',
	justifyContent: 'center',
	'& > button:last-of-type': {
		marginRight: 0,
	},
}));

export const FlexibleWrapper = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'center',
	width: '100%',
}));
export const FlexibleWrapperContent = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	'@media(min-width: 601px) ': {
		width: '330px',
	},
}));
